import { formatDate, isValid, parseISO } from "date-fns";
import { cs, enUS } from "date-fns/locale";
import i18next from "i18next";
import { capitalizeFirstLetter } from "web_myplann/Shared/Utils/capitalizeFirstLetter";
import { DateFormat } from "web_myplann/Shared/Utils/dateFormats";

export const ISO_DATE_FORMAT: string = DateFormat.Iso;
export const DEFAULT_DATE_FORMAT: string = DateFormat.Display;
export const SHORT_DATE_FORMAT: string = DateFormat.DisplayShort;
export const DATE_TIME_FORMAT: string = DateFormat.DisplayWithTime;

export const dateFormatter = (
	val: Date | string | null | undefined,
	dateFormat = DEFAULT_DATE_FORMAT,
	emptyVal = "",
) => (val ? formatDate(val, dateFormat) : emptyVal);

export const formatApiDate = (date: Date) => formatDate(date, ISO_DATE_FORMAT);

export const dateTimeFormatter = (
	val: Date | string | null | undefined,
	emptyVal = "",
) => {
	if (!val) return emptyVal;

	const parsed = typeof val === "string" ? parseISO(val) : val;
	if (!isValid(parsed)) return emptyVal;

	const hasTime =
		parsed.getHours() !== 0 ||
		parsed.getMinutes() !== 0 ||
		parsed.getSeconds() !== 0;

	return formatDate(parsed, hasTime ? DATE_TIME_FORMAT : DEFAULT_DATE_FORMAT);
};

export const monthYearFormatter = (
	val: Date | string | null | undefined,
	emptyVal = "",
) => {
	if (!val) return emptyVal;

	const locale = i18next.language?.toLowerCase().startsWith("en") ? enUS : cs;

	return capitalizeFirstLetter(
		formatDate(val, DateFormat.MonthYearLong, { locale }),
	);
};
